var defaultLogger = console;
export { defaultLogger };